// AskIAM UI Theme - Typography
// Based on Segoe UI / system font stack from the original portal

export const typography = {
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'sans-serif',
  ].join(','),
  monoFontFamily: "'Consolas', 'Courier New', monospace",
  h1: {
    fontSize: '1.5rem',
    fontWeight: 700,
  },
  h2: {
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  h3: {
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  h4: {
    fontSize: '1.1rem',
    fontWeight: 600,
  },
  body1: {
    fontSize: '0.95rem',
  },
  body2: {
    fontSize: '0.875rem',
  },
  caption: {
    fontSize: '0.85rem',
    lineHeight: 1.5,
  },
  button: {
    textTransform: 'none' as const,
    fontWeight: 600,
  },
} as const;
